import Cookies from 'js-cookie';
import {getQuery} from '@/common/utils/urlUtils.js';

const supportLanguages = ['ko', 'en', 'zh-tw', 'id'];

export function detectLanguage() {
    const langCandidates = getLangCandidates();
    let selected;

    for (let candidate of langCandidates) {
        if (candidate.lang !== 'zh-tw') {
            candidate.lang = candidate.lang.split('-')[0];
        }
        if (candidate.lang === 'in') {
            candidate.lang = 'id';
        }

        if (checkSupportLanguage(candidate.lang)) {
            selected = candidate;
            break;
        }
    }

    if (!selected) {
        selected = {lang: supportLanguages[0], force: false};
    }

    if (selected.force) {
        Cookies.set('lang', selected.lang);
    }

    return selected.lang;
}

function checkSupportLanguage(lang) {
    return supportLanguages.indexOf(lang) > -1;
}

function getLangCandidates() {
    const langCandidates = [];

    // 1순위 forceLang 쿠키
    const cookieForceLang = Cookies.get('forceLang')?.toLowerCase();

    if (cookieForceLang) {
        langCandidates.push({lang: cookieForceLang, force: true});
    }

    // 2순위 lang 쿼리
    const query = getQuery();
    const queryLang = query.lang?.toLowerCase().replace('_', '-');

    if (queryLang) {
        langCandidates.push({lang: queryLang, force: true});
    }

    // 3순위 lang 쿠키
    const cookieLang = Cookies.get('lang')?.toLowerCase();

    if (cookieLang) {
        langCandidates.push({lang: cookieLang, force: false});
    }

    // 4순위 브라우저 언어
    const browserLang = (navigator.language || navigator.userLanguage).toLowerCase().replace('_', '-');
    langCandidates.push({lang: browserLang, force: false});

    return langCandidates;
}
